import { useQuery } from '@tanstack/react-query';

import { getHolderDetailAndRequiredDocumentsRequest } from '@/api/operation';

import { QUERY_KEY } from '@/constants/query/operation';

import { selectLoggedInUser } from '@/redux/auth/selectors';
import { selectUserHolderJointMinor } from '@/redux/user-data/selectors';

import { isAdultUser } from '@/utils/user';

import { useAppSelector } from '../redux';

export const useGetMinorDetailAndRequiredDocuments = () => {
  const loggedUser = useAppSelector(selectLoggedInUser);
  const holderJointMinor = useAppSelector(selectUserHolderJointMinor);
  const isAdultJointAccount = isAdultUser(loggedUser);
  const { data, isLoading, refetch } = useQuery({
    queryKey: [
      QUERY_KEY.GET_OPERATION_AND_REQUIRED_DOCUMENTS,
      loggedUser?.operationId,
      holderJointMinor?.clientId,
    ],
    queryFn: async () => {
      return getHolderDetailAndRequiredDocumentsRequest(
        loggedUser?.operationId || '',
        holderJointMinor?.clientId || 0,
      );
    },
    enabled: isAdultJointAccount && holderJointMinor?.clientId !== undefined,
    // Discard cache on unmount to prevent stale data overwriting Redux state.
    gcTime: 0,
  });

  return {
    data,
    isLoading,
    refetch,
  };
};
